/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useEffect, useState } from 'react'
import { view } from 'react-easy-state'
import { useTranslation } from 'react-i18next'
import liff from '@line/liff'

import FormItem from '../../components/generics/FormItem'
import AlertError from '../../components/generics/AlertError'
import ButtonChakra from '../../components/generics/ButtonChakra'
import userStore from '../../core/stores/Viriyah/userStore'
import { LoadingSpinerDataComponent } from '../../components/generics/LoadingData'

interface PDPAFormProp {
  active: string
  dataPdpa: Object
  description: string
  errorMessage: string
}

interface PDPADescriptionProps {
  PDPAForm: any
  setPDPAForm: any
  t: any
}

const sleep = async (ms: number | undefined) => await new Promise(resolve => setTimeout(resolve, ms))

const data = [
  { value: '0', label: 'ไม่ยินยอม' },
  { value: '1', label: 'ยินยอม' }
]

function PDPADescription({ PDPAForm, setPDPAForm, t }: PDPADescriptionProps) {
  const confirmClick = (): any => {
    try {
      const { active, dataPdpa } = PDPAForm
      const pathName = 'PDPAVerify'
      const payload = {
        AgeRangeCode: '',
        CollectionPointGuid: dataPdpa.Guid,
        CompanyId: 1,
        WebSiteId: +dataPdpa.WebsiteId,
        Uid: userStore.userId,
        FullName: '',
        Email: '',
        PhoneNumber: '',
        FromBrowser: 'Line',
        FromWebsite: 'Line',
        VerifyType: '-',
        EventCode: '',
        IdCardNumber: '',
        ExpiredDateTime: '',
        ConsentSignature: '',
        Purpose: [
          {
            PurposeGUID: dataPdpa.PurposeList.Guid,
            Active: +active,
            ExpiredDateTime: dataPdpa.PurposeList.ExpiredDateTime
          }
        ],
        CollectionPointCustomField: []
      }

      window.bizlink
        .trigger('POST', {
          payload,
          pathName
        })
        .then((response: any) => {
          console.log('PDPAVerify response : ', response)
          if (!response.error) {
            console.log('PDPAVerify success!!!')
          } else {
            console.log('PDPAVerify not success!!!')
          }
          liff.closeWindow()
        })
        .catch(err => {
          console.log('error', pathName, 'with', err.message)
          setPDPAForm({
            ...PDPAForm,
            errorMessage: err as string
          })
        })
    } catch (error: unknown) {
      setPDPAForm({
        ...PDPAForm,
        errorMessage: error as string
      })
    }
  }

  // status = true, is not emtpy or not error
  const checkFormInput = (): boolean => {
    if (PDPAForm.active !== null) {
      return false
    } else {
      return true
    }
  }

  return (
    <section id="pdpa-page" className="pt-16">
      <div className="container">
        {PDPAForm?.errorMessage !== '' ? <AlertError message={PDPAForm?.errorMessage} /> : null}
        <h6 id="pdpa-title">
          {t('viriyah.PDPA-page.title1')}
          <br />
          {t('viriyah.PDPA-page.title2')}
        </h6>
        <div className="form-pdpa">
          <div className="part">
            <p className="mb-4">{PDPAForm.description}</p>
            <FormItem
              select="radio"
              value={PDPAForm.active}
              onChange={(e: string) => setPDPAForm({ ...PDPAForm, active: e })}
              options={data}
            />
          </div>
        </div>
      </div>
      <div className="bottom-section">
        <ButtonChakra
          customBgColor="#0033A2"
          textColor="white"
          type="submit"
          isDisable={checkFormInput()}
          onClick={() => confirmClick()}
        >
          {t('viriyah.PDPA-page.botton-confirm')}
        </ButtonChakra>
      </div>
    </section>
  )
}

export default view(() => {
  const { t } = useTranslation()
  const [firstTimeUse, setFirstTimeUse] = useState(false)
  const [LoadingStatus, setLoadingStatus] = useState(true)
  const [PDPAForm, setPDPAForm] = useState<PDPAFormProp>({
    active: '',
    dataPdpa: {},
    description: '',
    errorMessage: ''
  })

  useEffect(() => {
    const getPDPA = async () => {
      try {
        if (userStore.userId === '') {
          await sleep(2500)
        }
        console.log('getPDPA')
        const pathName = 'getPDPA'
        const payload = {
          userId: userStore.userId
          // userId: 'Ud0b40d2aca6d0cf6e877b840b09796f2'
        }

        await window.bizlink
          .trigger('POST', {
            payload,
            pathName
          })
          .then((response: any) => {
            if (response) {
              const activePdpa = response.PDPAVerifys.Active === true ? '1' : '0'

              setPDPAForm({
                ...PDPAForm,
                active: activePdpa,
                dataPdpa: response,
                description: response.PurposeList.Description
              })
            } else {
              const errorMessage = t('viriyah.validate-message.service-error') + ` (API: getPDPA, ${response.message})`
              setPDPAForm({
                ...PDPAForm,
                errorMessage
              })
            }
            setLoadingStatus(false)
          })
          .catch(err => {
            const message = err.response.data.error.message ?? err.message
            const errorMessage = t('viriyah.validate-message.service-error') + ` (API: getPDPA, ${message})`
            setPDPAForm({
              ...PDPAForm,
              errorMessage
            })
            setLoadingStatus(false)
          })
      } catch (error: unknown) {
        setPDPAForm({
          ...PDPAForm,
          errorMessage: error as string
        })
        setLoadingStatus(false)
      }
    }

    if (!firstTimeUse) {
      void getPDPA()
      setFirstTimeUse(true)
    }
  }, [])

  return (
    <>
      {LoadingStatus ? (
        <LoadingSpinerDataComponent />
      ) : (
        <PDPADescription PDPAForm={PDPAForm} setPDPAForm={setPDPAForm} t={t} />
      )}
    </>
  )
})
